export enum EnrollmentDiscrepantStatus {
  Total = 0,
  Outstanding = 1,
  InProgress = 2,
  Successful = 3,
}
